import {vnTemplate} from "./vnTemplate";

declare var ko: any;

export class filterDropdown_template extends vnTemplate {

    protected getTemplateHtml(): string {

        return `
                    <select data-bind="
                        options: options,
                        optionsText: 'name',
                        optionsValue: 'id',
                        value: selectedOption,
                        event: { change: onChangeFilterAction },
                        optionsAfterRender: onOptionsAfterRender,
                        disable: disable
                    "></select>
            `;
    }

    protected getTemplateName(): string {
        return 'filterDropdown-template';
    }

    protected buildViewModel(): object {

        let huit_neuf_this = this;

        return {
            label: ko.observable("")
            ,options: ko.observableArray([{ id: null, name: 'all'}])
            ,selectedOption: ko.observable(0)
            ,setOptions: function (data, event) { huit_neuf_this.setOptions(data); }
            ,setLabel: function (data, event) { huit_neuf_this.setLabel(data); }
            ,setSelectedOption: function (data, event) { huit_neuf_this.setSelectedOption(data); }
            ,onChangeFilterAction: function (data, event) { huit_neuf_this.onChangeFilterAction(data); }
            ,onOptionsAfterRender: function (option, item) { huit_neuf_this.onOptionsAfterRender(option, item); }
            ,disable: ko.observable(false)
        };
    }

    public onChangeFilterAction(data) {

        this.caller.filterDropdownOnChange(this.idElement);
    }

    public onOptionsAfterRender(option: any, item: any) {
        if (!item) {
            return;
        }
        let isDisabled = false;
        const prop = (item as any).disabled;
        if (typeof prop === 'function') {
            try {
                isDisabled = !!prop();
            } catch (e) {
                // Fallback in case callable isn't a KO observable
                isDisabled = !!prop;
            }
        } else {
            isDisabled = !!prop;
        }
        if (isDisabled) {
            try {
                option.setAttribute('disabled', 'disabled');
            } catch (e) {
                // ignore
            }
        } else {
            try {
                option.removeAttribute('disabled');
            } catch (e) {
                // ignore
            }
        }
    }

    public setSelectedOption(optionId: any) {

        this.getTemplateViewModel().selectedOption(optionId);
    }

    public setOptions(options) {

        let temp = this.onChangeFilterAction;
        this.onChangeFilterAction = function(){};

        this.getTemplateViewModel().options(options);

        this.onChangeFilterAction = temp;
    }

    public getOptions(): {id: number, name: string, disabled?: boolean}[]|null {
        return this.getTemplateViewModel().options()
    }

    public getSelectedOption(): {id: number, name: string}|null
    {
        const vm = this.getTemplateViewModel();
        const selectedOption = vm.selectedOption();
        if (!selectedOption) {
            return null;
        }

        const option = vm.options().find((option) => option.id === selectedOption);

        return option? option : null;
    }


    public setLabel(label : string) {

        this.getTemplateViewModel().label(label);
    }

    public setDisable(disable: boolean) {

        this.getTemplateViewModel().disable(disable);
    }


    // this needs to be called after the options are set and after the options are rendered
    // to make sure the disabled options are rendered correctly in the dropdown
    // Ideal place to call this function is during an API call in a module
    public setOptionDisabled(id: any, disabled: boolean) {
        const vm = this.getTemplateViewModel();
        const opts = vm.options && vm.options();
        if (!opts || !opts.length) {
            return;
        }

        const newArr = opts.map((option: any) =>
            option && option.id === id
                ? { ...option, disabled: !!disabled }
                : option
        );

        vm.options(newArr);
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template.ts